import { createAction, props } from '@ngrx/store';
import { OracleStorageActionModel } from '@models/common/oracle-storage-action.model';
import { AreaModel } from '@models/configuration/area.model';

export const createArea = createAction(
    '[Area] Create Area',
    props<{ action: OracleStorageActionModel<AreaModel> }>()
);

export const createAreaSuccess = createAction(
    '[Area] Create Area Success',
    props<{ Area: AreaModel }>()
);

export const searchAreas = createAction(
    '[Areas] Search Areas',
    props<{ action: OracleStorageActionModel<AreaModel> }>()
);

export const searchAreasSuccess = createAction(
    '[Areas] Search Areas Success',
    props<{ Areas: AreaModel[] }>()
);

export const updateArea = createAction(
    '[Area] Update Area',
    props<{ action: OracleStorageActionModel<AreaModel> }>()
);

export const updateAreaSuccess = createAction(
    '[Area] Update Area Success',
    props<{ Area: AreaModel }>()
);

export const selectArea = createAction(
    '[Area] Select Area',
    props<{ Area: AreaModel }>()
);

export const deleteArea = createAction(
    '[Area] Delete Area',
    props<{ action: OracleStorageActionModel<AreaModel> }>()
);

export const deleteAreaSuccess = createAction(
    '[Area] Delete Area Success',
    props<{ Area: AreaModel }>()
);

export const resetLoading = createAction(
    '[Loading] Reset Loading Success'
);